import React, { Component, Fragment } from 'react';
import 'styled-components/macro'
import Header from './Header'
import Joke from './Joke'
import { connect } from 'react-redux'
import { fetchJoke } from '../actions'
import { Button } from './Button'
import { Container } from './Container'
import Footer from './Footer'
import styled from 'styled-components'
import 'styled-components/macro'

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
`

const Content = styled.div`
    flex: 1; 
`

class App extends Component {
    componentDidMount() {
        this.props.fetchJoke()
    }

    renderJoke = () => { 
        return (
            <Fragment>
                <Joke joke={this.props.joke} />
                
                {this.props.joke.isPending ? null : <Button onClick={this.props.fetchJoke}>Get Joke</Button>}
            </Fragment>
        )
    }

    render() { 
        return (
            <Wrapper>
                <Content>
                <Header /> 
                    <Container>
                        {this.renderJoke()}
                    </Container>
                </Content>
                <Footer />
            </Wrapper>
        );
    }
}

const mapStateToProps = (state) => {
    return { 
        joke: state.joke
    }
}
 
export default connect(mapStateToProps, {
    fetchJoke
})(App);